import model from './model';
import SessionDetailsPage from './pages/SessionDetailsPage';

model.routes.setRoutes({
  detailsRoute: {
    component: SessionDetailsPage,
  },
});
